import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundStatusAuditLog.List.IRequest;
type Response = Api.Sales.ContractRefundStatusAuditLog.List.IResponse;
type Headers = Api.Sales.ContractRefundStatusAuditLog.List.IHeaders;
const url = '/api/Sales/ContractRefundStatusAuditLog';
export default async function contractRefundStatusAuditLogListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
